module.exports = __webpack_public_path__ + "static/media/regiless_user_onboarding_01_2x.e14dfd45.png";